import type { DataLayerItemObject, ServiceObject } from '../../components/types'
import { pushDataObject } from '../../data-layer'
import {
  getCartType,
  getDataLayerProducts,
  getDataLayerServices,
  getShippingType
} from '../../utils'

export type AddShippingInfoProps = {
  products: DataLayerItemObject[]
  services: ServiceObject[]
  cart: {
    value: number
    discount: number
  }
  freightCost: number
}

export const pushAddShippingInfo = (props: AddShippingInfoProps) => {
  const { products, services, cart, freightCost } = props

  const dataLayerProducts = getDataLayerProducts(products)
  const dataLayerServices = getDataLayerServices(services)
  const dataLayerItems = [...dataLayerProducts, ...dataLayerServices]

  const shopNameItems = dataLayerProducts.map((item) => item.seller)
  const cartType = getCartType(shopNameItems)

  const shippingTypeItems = dataLayerProducts.map((item) => item.delivery_type)
  const shippingType = getShippingType(shippingTypeItems)

  pushDataObject({
    _clear: true,
    event: 'add_shipping_info',
    items: dataLayerItems,
    shipping: {
      price: freightCost || undefined,
      type: shippingType
    },
    cart: {
      value: cart.value,
      discount: cart.discount || undefined,
      type: cartType
    }
  })
}


export const pushFunnelDelivery = (props: AddShippingInfoProps) => {
  const { products, services, cart, freightCost } = props

  const dataLayerProducts = getDataLayerProducts(products)
  const dataLayerServices = getDataLayerServices(services)
  const dataLayerItems = [...dataLayerProducts, ...dataLayerServices]

  const shopNameItems = dataLayerProducts.map((item) => item.seller)
  const cartType = getCartType(shopNameItems)

  const shippingTypeItems = dataLayerProducts.map((item) => item.delivery_type)
  const shippingType = getShippingType(shippingTypeItems)

  pushDataObject({
    _clear: true,
    event: 'checkout_funnel',
    funnel: {
      current_step: 'Entrega'
    },
    items: dataLayerItems,
    shipping: {
      price: freightCost || undefined,
      type: shippingType
    },
    cart: {
      value: cart.value,
      discount: cart.discount || undefined,
      type: cartType
    }
  })
}